import * as Vue from 'vue';

// const [ymaps3Vue] = await Promise.all([ymaps3.import('@yandex/ymaps3-vuefy'), ymaps3.ready]);

// export const vuefy = ymaps3Vue.vuefy.bindTo(Vue);
// //export const {YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } = vuefy.module(ymaps3);

// export const {
// 	YMap,
// 	YMapHint,
// 	YMapDefaultSchemeLayer,
// 	YMapDefaultFeaturesLayer,
// 	YMapListener,
// 	YMapMarker,
// 	YMapControls,
// 	YMapControl,
// 	YMapFeature,
// 	YMapFeatureDataSource,
// 	YMapCollection
// } = vuefy.module(ymaps3);

// добавляем loader для пакета, где указываем из какого CDN загружать
ymaps3.import.registerCdn('https://cdn.jsdelivr.net/npm/{package}', [
  '@yandex/ymaps3-default-ui-theme@latest'
]);

const [ymaps3Vue, defaultUiTheme] = await Promise.all([
  ymaps3.import('@yandex/ymaps3-vuefy'), 
  ymaps3.import('@yandex/ymaps3-default-ui-theme'),
  ymaps3.ready
]);

export const vuefy = ymaps3Vue.vuefy.bindTo(Vue);

export const {
  YMap,
  YMapHint,
  YMapDefaultSchemeLayer,
  YMapDefaultFeaturesLayer,
  YMapListener,
  YMapMarker,
  YMapControls,
  YMapControl,
  YMapFeature,
  YMapFeatureDataSource,
  YMapCollection,
  YMapDefaultMarker
} = {
  ...vuefy.module(ymaps3),
  ...vuefy.module(defaultUiTheme)
};